import { useCallback, useState } from "react";
import { useThirdPartyApi } from "~/api/GeneratedApi";
import { setVessels } from "~/redux/reducers/dataReducer";
import { useAppDispatch, useAppSelector } from "~/redux/store/store";
import { useCustomQuery } from "~/utils/hooks/useCustomQuery";
import { aisVesselToMapItem } from "../functions/dataConverters";
import { VesselMapItem } from "../types/mapItems";

type ReturnType = {
  fetchVesselData: (start: boolean) => Promise<void>;
};

function useAISVessels(): ReturnType {
  const [started, setStarted] = useState(false);
  const { getAISItems } = useThirdPartyApi();
  const dispatch = useAppDispatch();
  const mapType = useAppSelector((s) => s.map.mapType);

  useCustomQuery("vessel-locations", () => getAISItems(), {
    enabled: started && mapType === "2d",
    refetchInterval: 30000,
    onSuccess: (data) => {
      const tempData: VesselMapItem[] = [];
      data.forEach((d) => {
        tempData.push(aisVesselToMapItem(d));
      });
      // Update to redux
      dispatch(setVessels(tempData));
    },
  });

  // eslint-disable-next-line @typescript-eslint/require-await
  const fetchVesselData = useCallback(async (start: boolean) => {
    setStarted(start);
  }, []);

  return { fetchVesselData };
}

export default useAISVessels;
